import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import DepositHead from './DepositHead'
import DepositMain from './DepositMain'

const DepositHome = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = Cookies.get('user_id');
    if (!userId) {
      console.error('Please Login First.');
      navigate('/login');
    }
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12 mx-auto bg-color">
            <DepositHead />
            <DepositMain />
          </div>
        </div>
      </div>
    </>
  )
}

export default DepositHome;
